module.exports = __webpack_public_path__ + "img/010任向军.2067971e.png";